var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"circle":"","icon":_vm.icon,"type":_vm.type,"title":_vm.title,"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }